<template>
    

	<div class="app-principal">	
		<div class="app-topo">
            <top-bar title="Receitas/Despesas" :subtitle="tituloRegime" exibeVoltar="true" historyback="false" @navigate="navigate"
                navigateto="financeiro/receitasdespesas"/>
      
        </div>
		<div class="app-centro-sem-rodape">
            <div class="div-principal">
                <h3>Selecione o mês/ano:</h3>
                <div class="div-linha">
                    <div class="label">Mês</div>
                    <div class="campo">
                        <select name="mes" class="select"  v-model="mes">
                            <option value="1">Janeiro</option>
                            <option value="2">Fevereiro</option>
                            <option value="3">Março</option>
                            <option value="4">Abril</option>
                            <option value="5">Maio</option>
                            <option value="6">Junho</option>
                            <option value="7">Julho</option>
                            <option value="8">Agosto</option>
                            <option value="9">Setembro</option>
                            <option value="10">Outubro</option>
                            <option value="11">Novembro</option>
                            <option value="12">Dezembro</option>
                        </select>
                    </div>
                </div>
                <div class="div-linha">
                    <div class="label">Ano</div>
                    <div class="campo">
                        <select name="ano" id="selectano" class="select"  v-model="ano">
                        </select>
                    </div>

                </div>
                <br/>
                <div class="div-linha">
                    <botao 
                        type="button"
                        font_awesome_class="" 
                        label="Continuar"
                        @click.native="exibeReceitasDespesas"/>
                </div>

            </div>      
        </div>
		
	</div>

</template>

<script>
import TopBar from '@/components/layout/TopBar.vue';
import Botao from '@/components/shared/Botao.vue';

export default {
    name: 'ReceitasDespesasSelecionaMesAno',
    components : {TopBar, Botao},
    props: ["regime"],
    data() {
        return {
            mes : 3,
            ano : 2020
        }        
    },


    mounted() {
        var select = document.getElementById('selectano');

        var date = new Date();

        this.mes = date.getMonth()+1;
        this.ano = date.getFullYear();

        for(var ano=this.ano-10, idx=0; ano<this.ano+5; ano++, idx++){

            var opcao = document.createElement("option");
            
            opcao.text = ano;

            if(this.ano==ano){
                opcao.selected = true;
            }

            select.add(opcao, idx);
        }

        this.ano = date.getFullYear();


    },

    computed : {
        tituloRegime: function() {
            if(this.regime=='caixa'){
                return `Regime de caixa`;
            } else {
                return `Regime de competência`
            }

        }
    },
    methods : {
        exibeReceitasDespesas: function(){
            this.$router.push(`/receitasdespesas/${this.regime}/${this.mes}/${this.ano}/1`);
        },
        navigate: function(){
            this.$router.push(`/financeiro/receitasdespesas`);
        }

        

    }
}
</script>

<style scoped>
	.select:focus{
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);	
		transition: all  0.2s ease-in-out;
		outline: none;
		border: 1px solid #428bca;
	}
	
	.select{
		font-size: 18px;
		
		border: 1px solid #dedede;
		
		padding: 10px;
		width: calc(100% - 22px);	
		transition: all  0.2s ease-in-out;	
        height: 44px;	
        width: 100%;
	
    }

    .div-principal{
        margin: 20px 10px;
        display:  table;
        width: calc(100% - 20px);
    }
    
    .div-linha{
        float: none;
        display:  table;
        width: 100%;
    }

    .label{
        width: 20%;
        float: left;
        line-height: 44px;
    }

    .campo{
        width: 80%;
        float: left;
    }


</style>